// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Mandant } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetMandant(): (mandantId: string) => Promise<Mandant> {
  const getAPI = useGetApi();
  return useCallback(
    async (mandantId) => (await getAPI()).mandanten.getMandant({ mandantId }),
    [getAPI]
  );
}
